import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menu from '../Menu';
import Header from '../Header';
import Footer from '../Footer';

interface BreadcrumbItem {
    label: string;
    link?: string;
    active?: boolean;
}

interface AdminLayoutProps {
    children: React.ReactNode;
    useHeader?: boolean;
    pageTitle?: string;
    breadcrumbs?: BreadcrumbItem[];
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
    children,
    useHeader = true,
    pageTitle,
    breadcrumbs
}) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => setSidebarOpen(prev => !prev);
    const closeSidebar = () => setSidebarOpen(false);

    return (
        <>
            <Menu isOpen={sidebarOpen} onClose={closeSidebar} />
            {useHeader && <Header onToggleSidebar={toggleSidebar} />}
            {sidebarOpen && (
                <div
                    onClick={closeSidebar}
                    style={{
                        position: 'fixed', top: 0, left: 0,
                        width: '100vw', height: '100vh',
                        zIndex: 1025, background: 'rgba(0,0,0,0.3)'
                    }}
                />
            )}
            <main className={`nxl-container d-flex flex-column ${!useHeader ? 'top-0' : ''}`} style={{ minHeight: '100vh' }}>
                <div className="nxl-content flex-grow-1">
                    {(pageTitle || breadcrumbs) && (
                        <div className="page-header">
                            <div className="page-header-left d-flex align-items-center">
                                {pageTitle && (
                                    <div className="page-header-title">
                                        <h5 className="m-b-10">{pageTitle}</h5>
                                    </div>
                                )}
                                {breadcrumbs && (
                                    <ul className="breadcrumb">
                                        {breadcrumbs.map((item, index) => (
                                            <li key={index} className={`breadcrumb-item ${item.active ? 'active' : ''}`}>
                                                {item.link ? <Link to={item.link}>{item.label}</Link> : item.label}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    )}
                    {children}
                </div>
                <Footer />
            </main>
        </>
    );
};

export default AdminLayout;
